export default __webpack_public_path__ + "static/media/phone.1f1a82e8.svg";